import { render, staticRenderFns } from "./createBd.vue?vue&type=template&id=359bd03a&scoped=true&"
import script from "./createBd.vue?vue&type=script&lang=js&"
export * from "./createBd.vue?vue&type=script&lang=js&"
import style0 from "./createBd.vue?vue&type=style&index=0&id=359bd03a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359bd03a",
  null
  
)

export default component.exports